export enum ReviewType {
  Approved = 0,
  Rejected
}
